/**
 * Module slugs matching the backend ModuleEnum.
 * Used for route meta.module and access control.
 */
export const MODULES = {
    DASHBOARD: 'dashboard',
    PROFILE: 'profile',
    TEAM: 'team',
    CLIENTS: 'clients',
    CLIENT_REQUESTS: 'client_requests',
    CALLS: 'calls',
    EVENTS: 'events',
    TICKETS: 'tickets',
    NEWS: 'news',
    SURVEYS: 'surveys',
    CHIPTUNING: 'chiptuning',
    CHIPTUNING_NOTES: 'chiptuning_notes',
    PRODUCTS: 'products',
    QUOTES: 'quotes',
    INVOICES: 'invoices',
    INVOICES_ZOHO: 'invoices_zoho',
    MEDIA_LIBRARY: 'media_library',
    HELP_CENTER: 'help_center',
    CENTERS: 'centers',
    USERS: 'users',
    INFORMATION_REQUESTS: 'information_requests',
}

/**
 * Module labels for display purposes.
 */
export const MODULE_LABELS = {
    [MODULES.DASHBOARD]: 'Tableau de bord',
    [MODULES.PROFILE]: 'Mon profil',
    [MODULES.TEAM]: 'Équipe',
    [MODULES.CLIENTS]: 'Contacts',
    [MODULES.CLIENT_REQUESTS]: 'Demandes clients',
    [MODULES.CALLS]: 'Appels',
    [MODULES.EVENTS]: 'Événements',
    [MODULES.TICKETS]: 'Tickets',
    [MODULES.NEWS]: 'Actualités',
    [MODULES.SURVEYS]: 'Formulaires',
    [MODULES.CHIPTUNING]: 'Reprogrammation',
    [MODULES.CHIPTUNING_NOTES]: 'Reprogrammation - Notes',
    [MODULES.PRODUCTS]: 'Produits',
    [MODULES.QUOTES]: 'Devis',
    [MODULES.INVOICES]: 'Factures',
    [MODULES.INVOICES_ZOHO]: 'Factures Zoho',
    [MODULES.MEDIA_LIBRARY]: 'Réseaux sociaux',
    [MODULES.HELP_CENTER]: 'Centre d\'aide',
    [MODULES.CENTERS]: 'Centres',
    [MODULES.USERS]: 'Utilisateurs',
    [MODULES.INFORMATION_REQUESTS]: 'Demandes d\'informations',
}

/**
 * Module icons (Bootstrap icons class names).
 */
export const MODULE_ICONS = {
    [MODULES.DASHBOARD]: 'bi-house',
    [MODULES.PROFILE]: 'bi-person',
    [MODULES.TEAM]: 'bi-people',
    [MODULES.CLIENTS]: 'bi-person-lines-fill',
    [MODULES.CLIENT_REQUESTS]: 'bi-inbox',
    [MODULES.CALLS]: 'bi-telephone',
    [MODULES.EVENTS]: 'bi-calendar-event',
    [MODULES.TICKETS]: 'bi-ticket-detailed',
    [MODULES.NEWS]: 'bi-newspaper',
    [MODULES.SURVEYS]: 'bi-clipboard-data',
    [MODULES.CHIPTUNING]: 'bi-cpu',
    [MODULES.CHIPTUNING_NOTES]: 'bi-journal-text',
    [MODULES.PRODUCTS]: 'bi-box-seam',
    [MODULES.QUOTES]: 'bi-file-earmark-text',
    [MODULES.INVOICES]: 'bi-receipt',
    [MODULES.INVOICES_ZOHO]: 'bi-file-earmark-text',
    [MODULES.MEDIA_LIBRARY]: 'bi-share',
    [MODULES.HELP_CENTER]: 'bi-question-circle',
    [MODULES.CENTERS]: 'bi-building',
    [MODULES.USERS]: 'bi-people-fill',
    [MODULES.INFORMATION_REQUESTS]: 'bi-info-circle',
}
